/**
 * Onboarding Context Provider Component
 */

import { decodeFromUrl, encodeForUrl } from '../../utils/url';

import { find, findIndex, isEqual, some } from 'lodash';
import * as React from 'react';

import { OnboardingContext } from './';
import {
  IOnboardingContext,
  IUnlockedAchievement,
  OnboardingAchievementHandler,
  SerializedAchievements,
} from './types';

export const onboardingLocalStorageKey = 'ams:onboarding';

export class OnboardingContextProvider extends React.Component<{}, IOnboardingContext> {
  constructor(props) {
    super(props);

    this.state = {
      achievements: this.retrieveFromLocalStorage(),
      acknowledgeAchievement: this.acknowledgeAchievement,
      hasNewAchievement: this.hasNewAchievement,
      isNewAchievement: this.isNewAchievement,
      unlockAchievement: this.unlockAchievement,
    };
  }

  componentDidUpdate(_, prevState: IOnboardingContext) {
    if (!isEqual(this.state.achievements, prevState.achievements)) {
      this.saveToLocalStorage();
    }
  }

  acknowledgeAchievement: OnboardingAchievementHandler = (id) => {
    const achievements = [...this.state.achievements];
    achievements.splice(findIndex(achievements, { id }), 1, {
      id,
      acknowledged: true,
    });

    this.setState({ achievements });
  }

  hasNewAchievement = () => {
    return some(this.state.achievements, { acknowledged: false });
  }

  isNewAchievement: OnboardingAchievementHandler<boolean> = (id) => {
    const unlockedAchievement = find(this.state.achievements, { id });
    return !!unlockedAchievement && unlockedAchievement.acknowledged === false;
  }

  unlockAchievement: OnboardingAchievementHandler = (id) => {
    if (!find(this.state.achievements, { id })) {
      setTimeout(() => {
        this.setState(({ achievements }) => ({
          achievements: [...achievements, {
            id,
            acknowledged: false,
          }],
        }));
      }, 2000);
    }
  }

  retrieveFromLocalStorage() {
    return this.unserialize(
      decodeFromUrl<SerializedAchievements>(
        window.localStorage.getItem(onboardingLocalStorageKey),
      ) || []);
  }

  saveToLocalStorage() {
    window.localStorage.setItem(onboardingLocalStorageKey, encodeForUrl(this.serialize()));
  }

  serialize(): SerializedAchievements {
    return this.state.achievements.map(({ id }) => id);
  }

  unserialize(serializedAchievements: SerializedAchievements) {
    return serializedAchievements.map<IUnlockedAchievement>((id) => ({
      id,
      acknowledged: true,
    }));
  }

  render() {
    return (
      <OnboardingContext.Provider value={this.state}>
        {this.props.children}
      </OnboardingContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/onboarding/provider.tsx